import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { dismissNewYearAlert } from '../../actions/AlertsActions';
import Links from '../../constants/Links';
import { getCurrentDate } from '../../selectors/dateSelectors';
import { getCurrentYear } from '../../utils/dateUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NewYearAlert = () => {
  const dispatch = useDispatch();
  const currentDate = useSelector(getCurrentDate);
  const currentYear = getCurrentYear(currentDate);
  const handleClose = useCallback(() => {
    dispatch(dismissNewYearAlert(currentYear));
  }, [currentYear, dispatch]);
  return /*#__PURE__*/_jsxs(Alert, {
    closeable: true,
    use: "inline",
    marginBlockEnd: "400",
    onClose: handleClose,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "alerts.newYear.titleText"
    }),
    type: "info",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "alerts.newYear.text",
      options: {
        year: `${currentYear}`
      }
    }), /*#__PURE__*/_jsx(UIButton, {
      className: "m-left-5",
      href: Links.GOALS,
      size: "extra-small",
      use: "tertiary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "alerts.newYear.button"
      })
    })]
  });
};
export default NewYearAlert;